export default "__VITE_ASSET__Bwx5F85h__"